import { useAppDispatch, useAppSelector } from "../../App/hooks";
import Button from "../../Components/Button";
import { useState, useEffect } from "react";
import TextInput from "../../Components/TextInput";
import { toast } from "react-toastify";
import FullScreenLoading from "../../Components/Loading/FullScreenLoading";
import CheckBox from "../../Components/Checkbox";
import { packetErrorHandler } from "../../Utils/requestUtils";
import { IDeltaHedgeOrderEditValues } from "../../Interfaces/deltaHedgeOrder";
import { editDeltaHedgeOrder } from "../../Requests/deltaHedgeOrder";
import {
  setDeltaHedgeEditFlag,
  setDeltaHedgeEditRowValues,
} from "../../Features/DeltaHedgeOrder/deltaHedgeOrderSlice";

interface Props {
  isConditionId: boolean;
}
const EditOrder: React.FC<Props> = ({ isConditionId }) => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  const editOrderRowValues = useAppSelector(
    (store) => store.deltaHedgeOrder.editOrderRowValues
  );

  const [formValues, setFormValues] = useState<IDeltaHedgeOrderEditValues>({
    applyToSimilar: false,
    lockProfitTarget: editOrderRowValues?.targetPercent,
    id: editOrderRowValues?.id,
  } as IDeltaHedgeOrderEditValues);

  useEffect(() => {
    if (editOrderRowValues)
      setFormValues({
        applyToSimilar: false,
        lockProfitTarget: editOrderRowValues.targetPercent,
        id: editOrderRowValues.id,
        process: editOrderRowValues.process,
      });
  }, [editOrderRowValues]);

  const changeHandler = (name: string, value: any) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const onSendClick = () => {
    setLoading(true);
    const data = { ...formValues };
    if (isConditionId) {
      data.conditionId = editOrderRowValues?.id;
    }
    editDeltaHedgeOrder(data)
      .then((resp) => {
        toast.success(resp.msg);
        dispatch(setDeltaHedgeEditRowValues(null));
        dispatch(setDeltaHedgeEditFlag(false));
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const checkIsBtnDisabled = () => {
    if (!formValues.lockProfitTarget) return true;
    return false;
  };

  const onCancelClick = () => {
    dispatch(setDeltaHedgeEditRowValues(null));
    dispatch(setDeltaHedgeEditFlag(false));
  };

  // const getTabBoxActiveTab = () => {
  //   if (formValues.applyToAll) return 2;
  //   return 1;
  // };

  if (!editOrderRowValues) return null;

  return (
    <div className="flex flex-col justify-start items-start gap-[6px] whitespace-nowrap text-xs ml-2 border-2 border-gray-300 rounded py-3 px-2 mt-6">
      {loading ? <FullScreenLoading /> : <></>}

      <div className="grid grid-cols-2 gap-3 font-bold">
        <div className="flex flex-row justify-start items-center gap-2">
          <div>اکانت:</div>
          <div>{editOrderRowValues?.account}</div>
        </div>
        <div className="flex flex-row justify-start items-center gap-2">
          <div>فرایند:</div>
          <div>{editOrderRowValues?.process}</div>
        </div>
        <div className="flex flex-row justify-start items-center gap-2">
          <div>نماد اول:</div>
          <div
            className={`${
              editOrderRowValues?.orderSideStr?.split("_")[0]?.trim() === "خرید"
                ? "text-green-700"
                : "text-red-700"
            }`}
          >
            {editOrderRowValues?.instrumentName.split("_")[0]}
          </div>
        </div>
        <div className="flex flex-row justify-start items-center gap-2">
          <div>جهت اول:</div>
          <div
            className={`${
              editOrderRowValues?.orderSideStr?.split("_")[0]?.trim() === "خرید"
                ? "text-green-700"
                : "text-red-700"
            }`}
          >
            {editOrderRowValues?.orderSideStr?.split("_")[0] === "خرید"
              ? "خرید"
              : "فروش"}
          </div>
        </div>

        <div className="flex flex-row justify-start items-center gap-2">
          <div>نماد دوم:</div>
          <div
            className={`${
              editOrderRowValues?.orderSideStr?.split("_")[1]?.trim() === "خرید"
                ? "text-green-700"
                : "text-red-700"
            }`}
          >
            {editOrderRowValues?.instrumentName?.split("_")[1]?.trim()}
          </div>
        </div>
        <div className="flex flex-row justify-start items-center gap-2">
          <div>جهت دوم:</div>
          <div
            className={`${
              editOrderRowValues?.orderSideStr?.split("_")[1]?.trim() === "خرید"
                ? "text-green-700"
                : "text-red-700"
            }`}
          >
            {editOrderRowValues?.orderSideStr?.split("_")[1]?.trim()}
          </div>
        </div>
        <TextInput
          label="بازده هدف %"
          name="lockProfitTarget"
          value={formValues.lockProfitTarget?.toString()}
          onChange={changeHandler}
          classname="ltr !text-right"
        />
        <CheckBox
          checked={formValues.applyToSimilar}
          name="applyToSimilar"
          label="همه سفارشهای مشابه"
          onChange={changeHandler}
        />
      </div>

      <div className="flex flex-row justify-between items-center w-full mt-2">
        <Button
          onClick={onCancelClick}
          text="لغو"
          variant="outlined"
          className="!w-16 !h-6 !text-xs"
        />
        <Button
          onClick={onSendClick}
          text="ارسال"
          variant="contained"
          className="!w-16 !h-6 !text-xs"
          disabled={checkIsBtnDisabled()}
        />
      </div>
    </div>
  );
};

export default EditOrder;
